import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const CDN = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards';
const CARD_VALUES = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function findByNat(sub, nat) {
  return sub.find((s) => s.nat === nat);
}
function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// Reference: the players' range reads " R:100 - 3L" (spaced dash); every other range is " R:100-25K".
function MinMax({ max, wrapCol, spaced }) {
  const inner = (
    <div className={`teen1daycasino-container justify-content-end casino-min-max${wrapCol ? '' : ' w-100'}`}>
      <div>
        {' R:'}
        <span>100</span>
        {spaced ? ' - ' : '-'}
        <span>{max}</span>
      </div>
    </div>
  );
  return wrapCol ? <div className="col-12">{inner}</div> : inner;
}

// Even/Odd/suit/Under-Over back box: label back item + book sibling
function FancyBox({ item, label, isSuit, suits, onBet, exposures }) {
  const book = bookOf(exposures, item?.nat, item?.sid);
  return (
    <div className="casino-bl-box">
      <div
        className={`back casino-bl-box-item${isSuit ? ' casino-card-img' : ''}${suspCls(item)}`}
        onClick={isSusp(item) ? undefined : () => onBet(item.sid, 'back', item.b, item)}
      >
        {isSuit
          ? <span><img src={`${CDN}/${suits[0]}.png`} /> <img src={`${CDN}/${suits[1]}.png`} /></span>
          : <span className="casino-box-odd">{label}</span>}
      </div>
      {' '}
      <div className={`casino-book text-center ${bookCls(book)}`}>{fmtBook(book)}</div>
    </div>
  );
}

const BetTableAAA = memo(function BetTableAAA({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const amar = findByNat(sub, 'Amar');
  const akbar = findByNat(sub, 'Akbar');
  const anthony = findByNat(sub, 'Anthony');
  const players = [
    { item: amar, label: 'A. Amar' },
    { item: akbar, label: 'B. Akbar' },
    { item: anthony, label: 'C. Anthony' },
  ];

  const even = findByNat(sub, 'Even');
  const odd = findByNat(sub, 'Odd');
  const black = findByNat(sub, 'Black');
  const red = findByNat(sub, 'Red');
  const under7 = findByNat(sub, 'Under 7');
  const over7 = findByNat(sub, 'Over 7');

  const cardItems = CARD_VALUES.map((v) => findByNat(sub, `Card ${v}`));
  const cardOdds = cardItems[0]?.b || 0;

  return (
    <>
      {/* Desktop players */}
      <div className="row row5 d-none-small">
        {players.map(({ item, label }, i) => {
          const book = bookOf(exposures, item?.nat, item?.sid);
          return (
            <div key={i} className="col-4">
              <div className="casino-box-row">
                <div className="casino-nation-name"><b>{label}</b></div>
                <div className="casino-bl-box">
                  <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
                    <span className="casino-box-odd">{item?.b || 0}</span>
                  </div>
                  <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
                    <span className="casino-box-odd">{item?.l || 0}</span>
                  </div>
                </div>
                <div className={`casino-nation-name casino-book ${bookCls(book)}`}>{fmtBook(book)}</div>
              </div>
            </div>
          );
        })}
        <MinMax max="3L" wrapCol spaced />
      </div>

      {/* Mobile players */}
      <div className="row row5 d-none-big">
        {players.map(({ item, label }, i) => {
          const book = bookOf(exposures, item?.nat, item?.sid);
          return (
            <div key={i} className="casino-bl-box">
              <div className="casino-bl-box-item casino-odds-name">
                <b>{label}</b>
                {' '}
                <span className={`float-right ${bookCls(book)}`}>{fmtBook(book)}</span>
              </div>
              <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
                <span className="casino-box-odd">{item?.b || 0}</span>
              </div>
              <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
                <span className="casino-box-odd">{item?.l || 0}</span>
              </div>
            </div>
          );
        })}
        <MinMax max="3L" spaced />
      </div>

      {/* Even/Odd, Black/Red, Under/Over */}
      <div className="row row5 aaa-oe">
        <div className="col-lg-4 col-12">
          <div className="casino-box-row">
            <div className="casino-bl-box"><b>{even?.b || 0}</b></div>
            <div className="casino-bl-box"><b>{odd?.b || 0}</b></div>
          </div>
          <div className="casino-box-row">
            <FancyBox item={even} label="Even" onBet={handleBet} exposures={exposures} />
            <FancyBox item={odd} label="Odd" onBet={handleBet} exposures={exposures} />
          </div>
          <MinMax max="25K" />
        </div>
        <div className="col-lg-4 col-12">
          <div className="casino-box-row">
            <div className="casino-bl-box"><b>{black?.b || 0}</b></div>
            <div className="casino-bl-box"><b>{red?.b || 0}</b></div>
          </div>
          <div className="casino-box-row">
            <FancyBox item={black} isSuit suits={['spade', 'club']} onBet={handleBet} exposures={exposures} />
            <FancyBox item={red} isSuit suits={['heart', 'diamond']} onBet={handleBet} exposures={exposures} />
          </div>
          <MinMax max="25K" />
        </div>
        <div className="col-lg-4 col-12">
          <div className="casino-box-row">
            <div className="casino-bl-box"><b>{under7?.b || 0}</b></div>
            <div className="casino-bl-box"><b>{over7?.b || 0}</b></div>
          </div>
          <div className="casino-box-row">
            <FancyBox item={under7} label="Under 7" onBet={handleBet} exposures={exposures} />
            <FancyBox item={over7} label="Over 7" onBet={handleBet} exposures={exposures} />
          </div>
          <MinMax max="1L" />
        </div>
      </div>

      {/* 13 cards A-K */}
      <div className="mt-2">
        <div className="text-center w-100">
          <div className="casino-bl-box">
            <div className="casino-bl-box-item"><b>{cardOdds}</b></div>
          </div>
        </div>
        <div className="casino-cards text-center mt-1">
          {CARD_VALUES.map((val, i) => {
            const item = cardItems[i];
            const book = bookOf(exposures, item?.nat, item?.sid);
            return (
              <div key={val} className="casino-card-item" onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
                <div className={`card-image${suspCls(item)}`}>
                  <img src={`${CDN}/${val}.png`} />
                </div>
                {' '}
                <div className={`casino-book text-center ${bookCls(book)}`}>{fmtBook(book)}</div>
              </div>
            );
          })}
        </div>
        <MinMax max="5K" />
      </div>
    </>
  );
});

export default BetTableAAA;
